"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _AYPF6BURcjs = require('./AYPF6BUR.cjs');


var _XIM2KQSLcjs = require('./XIM2KQSL.cjs');



var _6P52IAFYcjs = require('./6P52IAFY.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/popover/popover-disclosure.tsx
var _misc = require('@ariakit/core/utils/misc');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "button";
var usePopoverDisclosure = _PTOCUU2Dcjs.createHook.call(void 0, function usePopoverDisclosure2({ store, ...props }) {
  const context = _6P52IAFYcjs.usePopoverProviderContext.call(void 0, );
  store = store || context;
  _misc.invariant.call(void 0, 
    store,
    process.env.NODE_ENV !== "production" && "PopoverDisclosure must receive a `store` prop or be wrapped in a PopoverProvider component."
  );
  const onClickProp = props.onClick;
  const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
    store == null ? void 0 : store.setAnchorElement(event.currentTarget);
    onClickProp == null ? void 0 : onClickProp(event);
  });
  props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
    props,
    (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _6P52IAFYcjs.PopoverScopedContextProvider, { value: store, children: element }),
    [store]
  );
  props = {
    ...props,
    onClick
  };
  props = _AYPF6BURcjs.usePopoverAnchor.call(void 0, { store, ...props });
  props = _XIM2KQSLcjs.useDialogDisclosure.call(void 0, { store, ...props });
  return props;
});
var PopoverDisclosure = _PTOCUU2Dcjs.forwardRef.call(void 0, function PopoverDisclosure2(props) {
  const htmlProps = usePopoverDisclosure(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.usePopoverDisclosure = usePopoverDisclosure; exports.PopoverDisclosure = PopoverDisclosure;
